import { render, staticRenderFns } from "./dragList.vue?vue&type=template&id=712b0405&scoped=true"
import script from "./dragList.vue?vue&type=script&lang=js"
export * from "./dragList.vue?vue&type=script&lang=js"
import style0 from "./dragList.vue?vue&type=style&index=0&id=712b0405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712b0405",
  null
  
)

export default component.exports